export default "__VITE_ASSET__4h4mPYFc__"